export const uiColumn = {
    name: 'UI Column',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        elementId: {
            name: 'Element id',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        blocks: {
            name: 'Blocks',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [
                    {
                        linkContentType: [
                            'uiAccordion',
                            'uiBlock',
                            'uiButton',
                            'uiCaption',
                            'uiCard',
                            'uiCarousel',
                            'uiDownloadButton',
                            'uiEmailSignup',
                            'uiFeatureComparisonTable',
                            'uiHelpScoutSearch',
                            'uiImage',
                            'uiImageList',
                            'uiLinkBlock',
                            'uiListCarousel',
                            'uiLoginContainer',
                            'uiMarkdown',
                            'uiMarketoForm',
                            'uiModal',
                            'uiNavImages',
                            'uiPlaceholder',
                            'uiPowerUp',
                            'uiPriceCard',
                            'uiPricingCalculator',
                            'uiPricingTable',
                            'uiRecommendShare',
                            'uiSocialShare',
                            'uiStack',
                            'uiTextBlock',
                            'uiTooltip',
                            'uiTrelloBoard',
                            'uiValueProp',
                            'uiVideo',
                            'uiVideoPlayer',
                            'uiWebinarLink'
                        ]
                    }
                ],
                linkType: 'Entry'
            }
        },
        properties: {
            name: 'Properties',
            type: 'Object',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        background: {
            name: 'Background',
            type: 'Object',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiColumn.js.map